/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StoreItemVolumeLinkViewerModel } from './StoreItemVolumeLinkViewerModel';
import {
    StoreItemVolumeLinkViewerModelFromJSON,
    StoreItemVolumeLinkViewerModelFromJSONTyped,
    StoreItemVolumeLinkViewerModelToJSON,
} from './StoreItemVolumeLinkViewerModel';

/**
 * viewerで表示される単行本情報
 * @export
 * @interface StoreItemVolumeViewerModel
 */
export interface StoreItemVolumeViewerModel {
    /**
     * 単行本のID
     * @type {number}
     * @memberof StoreItemVolumeViewerModel
     */
    id: number;
    /**
     * 単行本のタイトル
     * @type {string}
     * @memberof StoreItemVolumeViewerModel
     */
    title?: string;
    /**
     * ミック情報ページに表示するタイトル
     * @type {string}
     * @memberof StoreItemVolumeViewerModel
     */
    dataComicTitle?: string;
    /**
     * 単行本の詳細説明
     * @type {string}
     * @memberof StoreItemVolumeViewerModel
     */
    description?: string;
    /**
     * 単行本のサムネイルURL
     * @type {string}
     * @memberof StoreItemVolumeViewerModel
     */
    thumbnail?: string;
    /**
     * 単行本を購入できる各書店へのリンク
     * @type {Array<StoreItemVolumeLinkViewerModel>}
     * @memberof StoreItemVolumeViewerModel
     */
    store?: Array<StoreItemVolumeLinkViewerModel>;
    /**
     * 単行本を購入できるebookへのリンク
     * @type {Array<StoreItemVolumeLinkViewerModel>}
     * @memberof StoreItemVolumeViewerModel
     */
    ebook?: Array<StoreItemVolumeLinkViewerModel>;
}

/**
 * Check if a given object implements the StoreItemVolumeViewerModel interface.
 */
export function instanceOfStoreItemVolumeViewerModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function StoreItemVolumeViewerModelFromJSON(json: any): StoreItemVolumeViewerModel {
    return StoreItemVolumeViewerModelFromJSONTyped(json, false);
}

export function StoreItemVolumeViewerModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreItemVolumeViewerModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'dataComicTitle': !exists(json, 'dataComicTitle') ? undefined : json['dataComicTitle'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'thumbnail': !exists(json, 'thumbnail') ? undefined : json['thumbnail'],
        'store': !exists(json, 'store') ? undefined : ((json['store'] as Array<any>).map(StoreItemVolumeLinkViewerModelFromJSON)),
        'ebook': !exists(json, 'ebook') ? undefined : ((json['ebook'] as Array<any>).map(StoreItemVolumeLinkViewerModelFromJSON)),
    };
}

export function StoreItemVolumeViewerModelToJSON(value?: StoreItemVolumeViewerModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'dataComicTitle': value.dataComicTitle,
        'description': value.description,
        'thumbnail': value.thumbnail,
        'store': value.store === undefined ? undefined : ((value.store as Array<any>).map(StoreItemVolumeLinkViewerModelToJSON)),
        'ebook': value.ebook === undefined ? undefined : ((value.ebook as Array<any>).map(StoreItemVolumeLinkViewerModelToJSON)),
    };
}

